import { zodResolver } from '@hookform/resolvers/zod';
import { PropsWithChildren } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import useMarket from 'stores/useMarket';
import { isProductionBuildOrDevelopement } from 'utils/isProductionBuildPhaseOrDevelopment';
import { PUBLIC_ENV } from 'utils/publicEnv';
import { ConsultantLoginTypeEnum } from './enums/consultantLoginTypeEnum';
import { useTranslatedConsultantLoginSchema } from './hooks/useTranslatedConsultantLoginSchema';
import { ConsultantLoginFormType } from './types/ConsultantLoginFormType';

export default function ConsultantLoginFormProvider({ children }: PropsWithChildren) {
    const consultantLoginSchema = useTranslatedConsultantLoginSchema();
    const { backendDomain, market } = useMarket((state) => ({
        backendDomain: state.backendDomain,
        market: state.market,
    }));

    const methods = useForm<ConsultantLoginFormType>({
        defaultValues: { loginType: ConsultantLoginTypeEnum.Intranet },
        resolver: zodResolver(consultantLoginSchema),
    });

    const intranetProps = {
        action: isProductionBuildOrDevelopement()
            ? `${backendDomain}/api/autologin/login`
            : PUBLIC_ENV.NEXT_PUBLIC_INTRANET_URL,
        method: 'post',
    };

    return (
        <FormProvider {...methods}>
            <form {...intranetProps}>
                <input type="hidden" name="market" value={market} />
                {children}
            </form>
        </FormProvider>
    );
}
